import React, { useContext, useState } from 'react';
import emailjs from '@emailjs/browser';
import { ThemeContext } from '../../App';
import { motion, AnimatePresence } from 'framer-motion';

const ContactForm = () => {
  const { theme } = useContext(ThemeContext);
  const [contactDetail, setContactDetail] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState('Send');
  const [showSuccess, setShowSuccess] = useState(false);
  
  const onChange = (e) => {
    const { name, value } = e.target;
    setContactDetail((prevContactDetail) => ({ ...prevContactDetail, [name]: value }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    try {
      setFormStatus('Sending...');
      const result = await emailjs.sendForm(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAIL_PUBLIC_API_KEY
      );
      if (result) {
        setFormStatus('Sent');
        setShowSuccess(true);
        setContactDetail({
          name: '',
          email: '',
          message: ''
        });
        setTimeout(() => {
          setFormStatus('Send');
          setShowSuccess(false);
        }, 3000);
      }
    } catch (error) {
      console.log(error.text);
      setFormStatus('Error');
      setTimeout(() => {
        setFormStatus('Send');
      }, 2000);
    }
  };

  return (
    <div className="m-4 lead text-center pb-3 contact-form">
      <form onSubmit={sendEmail}>
        <div className="mb-4">
          <label 
            className="form-label" 
            htmlFor="name"
            style={{ 
              fontWeight: 600, 
              color: 'var(--text-primary)',
              textAlign: 'left',
              display: 'block'
            }}
          >
            Name
          </label>
          <input
            className="form-control"
            type="text"
            id="name"
            name="name"
            onChange={onChange}
            value={contactDetail.name}
            required
            style={{
              borderRadius: '12px',
              border: '2px solid var(--border-color)',
              padding: '0.75rem 1rem',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              backgroundColor: 'var(--bg-primary)',
              color: 'var(--text-primary)'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'var(--text-secondary)';
              e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 0, 0, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'var(--border-color)';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
        <div className="mb-4">
          <label 
            className="form-label" 
            htmlFor="email"
            style={{ 
              fontWeight: 600, 
              color: 'var(--text-primary)',
              textAlign: 'left',
              display: 'block'
            }}
          >
            Email
          </label>
          <input
            className="form-control"
            type="email"
            id="email"
            name="email"
            onChange={onChange}
            value={contactDetail.email}
            required
            style={{
              borderRadius: '12px',
              border: '2px solid var(--border-color)',
              padding: '0.75rem 1rem',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              backgroundColor: 'var(--bg-primary)',
              color: 'var(--text-primary)'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'var(--text-secondary)';
              e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 0, 0, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'var(--border-color)';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
        <div className="mb-4">
          <label 
            className="form-label" 
            htmlFor="message"
            style={{ 
              fontWeight: 600, 
              color: 'var(--text-primary)',
              textAlign: 'left',
              display: 'block'
            }}
          >
            Message
          </label>
          <textarea
            className="form-control"
            id="message"
            onChange={onChange}
            value={contactDetail.message}
            name="message"
            required
            rows="5"
            style={{
              borderRadius: '12px',
              border: '2px solid var(--border-color)',
              padding: '0.75rem 1rem',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              backgroundColor: 'var(--bg-primary)',
              color: 'var(--text-primary)',
              resize: 'vertical'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'var(--text-secondary)';
              e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 0, 0, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'var(--border-color)';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
        <AnimatePresence mode="wait">
          {showSuccess && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="mb-3"
              style={{
                color: '#28a745',
                fontWeight: 600
              }}
            >
              Message sent successfully! ✓
            </motion.div>
          )}
        </AnimatePresence>
        <motion.button
          className={`btn ${theme === 'light' ? 'btn-outline-dark' : 'btn-outline-light'} btn-lg`}
          type="submit"
          disabled={formStatus === 'Sending...' || formStatus === 'Sent'}
          whileHover={{ 
            scale: formStatus === 'Send' ? 1.02 : 1,
            boxShadow: formStatus === 'Send' ? "0 6px 16px rgba(0, 0, 0, 0.2)" : "none"
          }}
          whileTap={{ scale: formStatus === 'Send' ? 0.98 : 1 }}
          style={{
            borderRadius: '12px',
            borderWidth: '2px',
            fontWeight: 600,
            padding: '0.75rem 2.5rem',
            minWidth: '150px',
            transition: 'all 0.3s ease',
            opacity: formStatus === 'Sending...' || formStatus === 'Sent' ? 0.7 : 1
          }}
        >
          {formStatus}
        </motion.button>
      </form>
    </div>
  );
};

export default ContactForm;
